import { TransactionalSaleFormTabId, TransactionalSaleFormTabs } from "./index";

export const getMobileTransactionalSaleLotModalTabOrder = (
  saleLotId: string | undefined,
): TransactionalSaleFormTabId[] => {
  const tabs: TransactionalSaleFormTabId[] = [
    TransactionalSaleFormTabs.WHO,
    TransactionalSaleFormTabs.WHAT,
    TransactionalSaleFormTabs.PRICE,
  ];
  if (saleLotId) {
    tabs.push(TransactionalSaleFormTabs.NLIS);
  }
  tabs.push(TransactionalSaleFormTabs.REVIEW);
  return tabs;
};
